/* Pipli scroll-reveal — safe, product-page section reveal.
   Guarantees content visibility: only adds the hiding class when it will also reveal,
   reveals in-view items immediately, and a failsafe timer reveals everything after 2.6s. */
(function () {
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var docEl = document.documentElement;
    function run() {
      var main = document.getElementById('MainContent') || document.querySelector('main') || document.body;
      var secs = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
      if (!secs.length) return;
      docEl.classList.add('ppr-js');
      secs.forEach(function (s, i) {
        if (i === 0) return;                                   // never hide the first/main section
        if (s.querySelector('.pphero, .ppd__wrap')) return;    // skip hero / main product
        s.classList.add('ppr-reveal');
      });
      var targets = Array.prototype.slice.call(document.querySelectorAll('.ppr-reveal'));
      if (!targets.length) { docEl.classList.remove('ppr-js'); return; }
      // failsafe: reveal everything after 2.6s no matter what
      setTimeout(function () { targets.forEach(function (t) { t.classList.add('ppr-in'); }); }, 2600);
      if (!('IntersectionObserver' in window)) { targets.forEach(function (t) { t.classList.add('ppr-in'); }); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('ppr-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      var vh = window.innerHeight || 800;
      targets.forEach(function (t) {
        if (t.getBoundingClientRect().top < vh * 0.92) t.classList.add('ppr-in'); // already in view
        else io.observe(t);
      });
    }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
  } catch (e) { /* never break the page */ }
})();
